import React, { useState, useContext } from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Alarm from "@material-ui/icons/Alarm";
import Delete from "@material-ui/icons/Delete";
import FileCopy from "@material-ui/icons/FileCopy";
// import {deleteCard} from "../../../../../helpers/flowHelper";
import { useTranslation } from "react-i18next";
import { DataContext } from "../FlowConfiguration";
import { updateHistory } from "../../../../../helpers/historyHandler";
import cloneDeep from "lodash/cloneDeep";
import { removeFromTree } from "../../../../../helpers/flowHelper";
import { copyItem, cutItem, pasteItem } from "../../../../../helpers/ccp";
import Timeout from "../midSection/Timeout";
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../../recoil-store/recoil-state';

const options = {
  Cut: <FileCopy style={{ fontSize: "18px", marginRight: "5px" }} />,
  Copy: <FileCopy style={{ fontSize: "18px", marginRight: "5px" }} />,
  Paste: <FileCopy style={{ fontSize: "18px", marginRight: "5px" }} />,
  "Paste Inside": <FileCopy style={{ fontSize: "18px", marginRight: "5px" }} />,
  Delete: <Delete style={{ fontSize: "18px", marginRight: "5px" }} />,
  Timeout: <Alarm style={{ fontSize: "18px", marginRight: "5px" }} />,
};

function LongMenu(props) {
  const context = useContext(DataContext);
  const { t } = useTranslation();
  const { id, setRender, selectedItem, index, isCondition } = props;
  const [openTimeout, setOpenTimeout] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const setAlert = useSetRecoilState(alertState);

  const handleClick = (e) => {
    if (!e) var e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menu = async (option) => {
    if (option === "Delete") {
      let selectedAction = [];
      let clone = cloneDeep(context.items);
      await removeFromTree(clone, id, selectedAction);
      if (selectedAction[0]?.actionName === "Start") {
        context.setSelected({});
      } else {
        context.setSelected(selectedAction[0]);
      }
      updateHistory("flow", clone);
      context.setItems(clone);
    } else if (option === "Copy") {
      setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.AUTOMS.AUTOM-COPIED"), severity: 'success' }))
      copyItem(selectedItem);
    } else if (option === "Cut") {
      let selectedAction = [];
      let copiedItem = cloneDeep(selectedItem);
      let clone = cloneDeep(context.items);
      await removeFromTree(clone, id, selectedAction);
      if (selectedAction[0]?.actionName === "Start") {
        context.setSelected({});
      } else {
        context.setSelected(selectedAction[0]);
      }
      updateHistory("flow", clone);
      cutItem("flow", copiedItem, context);
      context.setItems(clone);
    } else if (option === "Paste") {
      pasteItem("flow", context, selectedItem);
    } else if (option === "Timeout") {
      // Timeout
      setOpenTimeout(true);
    } else if (option === "Debugging") {
      // debugging
      let elem = document.getElementById("debug-icon" + index);
      if (elem !== null && elem !== undefined) {
        elem.style = "visibility:hidden";
      }
    } else if (option === "Paste Inside") {
      pasteItem("flow", context, selectedItem, true);
      setRender(true);
    }
    handleClose(); // close
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        id={isCondition ? "long-menu-button-condition" : "long-menu-button"}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        style={{ zIndex: 99999999 }}
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "12ch",
          },
        }}
      >
        {Object.keys(options).map((option) =>
          !isCondition ? (
            option !== "Paste Inside" ? (
              <MenuItem
                key={option}
                style={{ color: "#212F3B", fontSize: "10px", fontWeight: 600 }}
                onClick={() => menu(option)}
              >
                {options[option]}
                {option}
              </MenuItem>
            ) : null
          ) : (
            <MenuItem
              key={option}
              style={{ color: "#212F3B", fontSize: "10px", fontWeight: 600 }}
              onClick={() => menu(option)}
            >
              {options[option]}
              {option}
            </MenuItem>
          )
        )}
      </Menu>
      {openTimeout && <Timeout setOpen={setOpenTimeout} />}
    </div>
  );
}

export default LongMenu;
